<div class="main-modal update-card-dialog">
  <div class="modal_header d-flex align-items-center justify-content-between">
    <div class="modal_header_inner d-flex align-items-center">
      <span class="material-icons green-text modal-header-icon mr-2" aria-hidden="true">credit_card</span>
      <h3 class="modal_title fw-600" id="update-card-title">{{ messages.title }}</h3>
    </div>
    <button type="button" class="close_modal" aria-label="Close" [disabled]="saving" (click)="onCancel()">
      <i class="material-icons" aria-hidden="true">close</i>
    </button>
  </div>

  <div class="modal-body">
    <p class="update-card-dialog__intro">{{ messages.intro }}</p>
    <ngx-stripe-card
      class="stripe-card"
      [options]="cardOptions"
      [elementsOptions]="elementsOptions"
      (change)="onCardChange($event)"
    ></ngx-stripe-card>
    <p class="update-card-dialog__error" *ngIf="errorMessage" role="alert">{{ errorMessage }}</p>
  </div>

  <div class="modal-footer update-card-dialog__actions">
    <button type="button" class="btn rounded_btn small_btn px-4 update-card-dialog__cancel" [disabled]="saving" (click)="onCancel()">
      Cancel
    </button>
    <button type="button" class="btn rounded_btn green_btn small_btn px-4" [disabled]="!canSave" (click)="onSave()">
      {{ saving ? messages.saving : 'Save Card' }}
    </button>
  </div>
</div>
